import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiAuth: {
      token: ''
    },
    patient: {
      data: ''
    },
    survey: {
      data: []
    },
    insurances: {
      data: {}
    }
  },
  mutations: {
    setApiToken (state, token) {
      state.apiAuth.token = token;
    },
    setPatientData (state, data) {
      state.patient.data = data;
    },
    setSurveyData (state, data) {
      state.survey.data.push(data);
    },
    updateSurveyData (state, data) {
      state.survey.data = data;
    },
    setInsurancesData (state, data) {
      state.insurances.data[data.type] = data.params;
    }
  },
  actions: {
    setApiToken (context, token) {
      context.commit('setApiToken', token);
    },
    setPatientData (context, data) {
      context.commit('setPatientData', data);
    },
    setSurveyData (context, data) {
      context.commit('setSurveyData', data);
    },
    updateSurveyData (context, data) {
      context.commit('updateSurveyData', data);
    },
    setInsurancesData (context, {type, params}) {
      context.commit('setInsurancesData', {type, params});
    }
  },
  getters: {
    API_TOKEN: (state) => {
      return state.apiAuth.token;
    },
    patientData: (state) => {
      return state.patient.data;
    },
    surveyData: (state) => {
      return state.survey.data;
    },
    insurancesData: (state) => {
      return state.insurances.data;
    }
  },
});
